import React, { createContext, useContext, useEffect, useState } from "react";
import { api, tokenStore, userStore } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => userStore.get());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = tokenStore.get();
    if (t && !user) {
      setLoading(true);
      api.get("/auth/me")
        .then((r) => { setUser(r.data); userStore.set(r.data); })
        .catch(() => tokenStore.clear())
        .finally(() => setLoading(false));
    }
  }, []); // eslint-disable-line

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    tokenStore.set(r.data.token);
    userStore.set(r.data.user);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    tokenStore.set(r.data.token);
    userStore.set(r.data.user);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => { tokenStore.clear(); setUser(null); };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
